module.exports = __webpack_public_path__ + "img/need1.bba61942.png";